import { useAuth0 } from '@auth0/auth0-react'

import { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'

import { Loading } from '../components/Loading'
import { cleanupAfterAuthDecline, getAuthErrorFromUrl, getPostDeclineLogoutReturnTo } from '../config/auth0'

const RedirectCallback = (): JSX.Element => {
  const { error, isAuthenticated, isLoading, logout } = useAuth0()
  const history = useHistory()
  const handledRef = useRef(false)

  useEffect(() => {
    if (isLoading || handledRef.current) return

    const urlError = getAuthErrorFromUrl()

    if (error || urlError) {
      handledRef.current = true
      cleanupAfterAuthDecline()
      // Clear Auth0 SSO session so retry shows login/signup, not Authorize App again.
      void logout({
        logoutParams: {
          returnTo: getPostDeclineLogoutReturnTo(),
        },
      })
      return
    }

    if (isAuthenticated) {
      handledRef.current = true
      // onRedirectCallback normally navigates away; this is a fallback.
      history.replace('/hospitals')
    }
  }, [error, history, isAuthenticated, isLoading, logout])

  return (
    <div className="bg-light-blue flex justify-center items-center min-h-screen relative">
      <Loading />
    </div>
  )
}

export default RedirectCallback
